import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import {
  ErrorUnexpected,
  OperationSuccessfully,
} from "../../../../../../const/Messages";
import * as HuaweiUgwDefaultParametersService from "../../../../../../service/HuaweiUgwDefaultParametersService";
import Loading from "../../../../../Common/Loading/Loading";

const initialValues = {
  id: "",
  ignoredCasesLog: false,
  ignoredCasesIr21: false,
  virtualApnOnlyCheckWithIR21: false,
};

/**
  @author Guilherme Almeida
  @date 14/08/2024
 */
export default function HuaweiUgwDefaultParameters() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    HuaweiUgwDefaultParametersService.getHuaweiUgwDefaultParameters()
      .then((itens) => {
        setValues(itens);
        setLoading(false);
      })
      .catch(() => {
        history.push("/", { message: ErrorUnexpected, messageType: "error" });
      });
  }, []); // eslint-disable-line

  const schema = Yup.object().shape({});

  function handleSave(values, actions) {
    HuaweiUgwDefaultParametersService.update(values)
      .then(() => {
        history.push("/settings/report/template/ugw/huawei/default", {
          message: OperationSuccessfully,
          messageType: "success",
        });
      })
      .catch((error) => {
        if (!error || !error.response || !error.response.data) {
          actions.setFieldError("virtualApnOnlyCheckWithIR21", ErrorUnexpected);
        } else if (error.response.data.title) {
          actions.setFieldError(
            "virtualApnOnlyCheckWithIR21",
            error.response.data.title
          );
        }
        actions.setSubmitting(false);
      });
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title">
            <h5>Huawei UGW Default Parameters</h5>
          </div>
          <div className="ibox-content">
            <Formik
              initialValues={values}
              validationSchema={schema}
              onSubmit={handleSave}
            >
              {() => (
                <Form>
                  <div className="font-weight-bold pt-2 pb-2">
                    <label>GENERAL</label>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="ignoredCases"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Ignored Cases:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <div className="d-flex align-items-baseline">
                        <Field type="checkbox" name="ignoredCasesLog" />
                        <label className="form-check-label pl-2">
                          Ignore value from LOG.
                        </label>
                        <span className="text-danger">
                          <ErrorMessage name="ignoredCasesLog" />
                        </span>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <Field type="checkbox" name="ignoredCasesIr21" />
                        <label className="form-check-label pl-2">
                          Ignore value from IR21.
                        </label>
                        <span className="text-danger">
                          <ErrorMessage name="ignoredCasesIr21" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2">
                    <label>Virtual APN</label>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="virtualApnOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field
                        type="checkbox"
                        name="virtualApnOnlyCheckWithIR21"
                      />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="virtualApnOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Link className="mr-1 btn btn-primary" to="/settings">
                      Cancel
                    </Link>
                    <Button variant="primary" type="submit">
                      Update
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Col>
    </Row>
  );
}
